
import { useConfig } from '@/helpers/config';
import actions from './actions'
import mutations from './mutations'

let state = {
    allFavorites: [],
    current: null,
    currentId: useConfig().ARTICLE_POST_ID || null
}

const ACTIONS = {
    ADD_FAVORITE: 'articles/addFavorite',
    GET: 'articles/get',
    GET_ALL_FAVORITES: 'articles/getAllFavorites',
    REMOVE_FAVORITE: 'articles/removeFavorite',
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }